import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import serviceLogo from '../assets/images/logoPDF.jpg';

const POPrintView = () => {
  const { id } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [po, setPO] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchPO();
  }, [id]);

  const fetchPO = async () => {
    try {
      // Fetch PO details
      const res = await axios.get(`${apiUrl}/inventory_crud.php?po_detail=${id}`);
      if (res.data && res.data[0] === "success") {
        setPO(res.data[1]);
        setItems(res.data[2] || []);
        setTimeout(() => window.print(), 300); // Auto trigger print dialog
      }
    } catch {
      setPO(null);
    }
  };

  if (!po) {
    return <div className="text-center p-10 text-gray-500">Loading...</div>;
  }


  // Handle the printing
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="p-8 bg-white max-w-3xl mx-auto text-sm print:text-black print:bg-white">
      <div className="mb-4">
        <button
          onClick={handlePrint}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 print:hidden"
        >
          Print
        </button>
      </div>

      <div className="text-center mb-6">
        <img
          src={serviceLogo}
          alt="logo"
          className="mx-auto mb-4 max-w-full"
        />
        <hr/>
        <h1 className="text-2xl font-bold">Purchase Order</h1>
        <div className="text-gray-500">PO #: {po.po_number}</div>
      </div>

      <div className="flex justify-between mb-6">
        <div>
          <div><strong>Vendor:</strong> {po.vendor}</div>
          <div><strong>Status:</strong> {po.status}</div>
        </div>
        <div>
          <div><strong>Created:</strong> {po.date_created}</div>
          <div><strong>Expected:</strong> {po.expected_date || '-'}</div>
        </div>
      </div>
      <div className="mb-6">
        <strong>Created By:</strong> {po.created_by}
      </div>
      <div className="mb-6">
        <strong>Job Number:</strong> {po.job_number || "-"}
      </div>
      <div className="mb-6">
        <strong>Notes:</strong>
        <div className="whitespace-pre-line text-gray-700">{po.notes}</div>
      </div>
      <table className="w-full border mt-6 mb-10">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">#</th>
            <th className="border px-2 py-1 text-left">Part</th>
            <th className="border px-2 py-1 text-left">Description</th>
            <th className="border px-2 py-1">Qty</th>
            <th className="border px-2 py-1">Price</th>
            <th className="border px-2 py-1">Total</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center p-4 text-gray-400">
                No items in PO.
              </td>
            </tr>
          ) : (
            items.map((item, idx) => (
              <tr key={item.id}>
                <td className="border px-2 py-1 text-center">{idx + 1}</td>
                <td className="border px-2 py-1">{item.device_name}</td>
                <td className="border px-2 py-1">{item.full_description}</td>
                <td className="border px-2 py-1 text-center">{item.quantity}</td>
                <td className="border px-2 py-1 text-center">${item.price?.toFixed(2)}</td>
                <td className="border px-2 py-1 text-center">
                  ${(item.quantity * item.price).toFixed(2)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="flex justify-between items-center mt-8">
        <div>
          <div className="border-t border-gray-400 mt-10 pt-6">
            <strong>Authorized By:</strong> ___________________________
          </div>
        </div>
        <div>
          <strong>Total:</strong>{" "}
          <span className="text-xl">
            ${items.reduce((sum, i) => sum + i.quantity * i.price, 0).toFixed(2)}
          </span>
        </div>
      </div>
      <style>{`
        @media print {
          button, .noprint { display: none !important; }
          body { background: white !important; }
        }
      `}</style>
    </div>
  );
};

export default POPrintView;
